import $ from 'jquery';
import './mpro.form-change-handlers.js';

// import mpro from './mpro.init';
import { doFetch, doXhr } from '../../remote/request.js';
import { loadPartial } from '../../remote/partial-content.js';
import MpModal from '../../modules/components/modal.js';
import { triggerEvent } from '../../util/dom.js';

/**
 * @param {string} str
 * @param {JQuery<HTMLElement>} $elem
 */
const replaceEventDetailKeywords = (str, $elem) => {
	if (str === '##value##') {
		return $elem.val();
	}
	return str;
};

/**
 * @param {any} obj
 * @param {JQuery<HTMLElement>} $elem
 */
const replaceEventDetailKeywordsRecursive = (obj, $elem) => {
	if (obj) {
		if (typeof obj === 'string') {
			obj = replaceEventDetailKeywords(obj, $elem);
		}
		else if (typeof obj === 'object') {
			if (Array.isArray(obj)) {
				for (const [i, v] of obj.entries()) {
					obj[i] = replaceEventDetailKeywordsRecursive(v, $elem);
				}
			}
			else {
				for (const s in obj) {
					if (Object.hasOwn(obj, s)) {
						obj[s] = replaceEventDetailKeywordsRecursive(obj[s], $elem);
					}
				}
			}
		}
	}
	return obj;
};

/**
 * @param {HTMLElement} element
 */
const handleSetFieldsChange = (element) => {

	const $elem = $(element);
	const elemType = $elem[0].nodeName;

	/** @param {*} setFields */
	const doSetFields = (setFields) => {
		for (const [fieldId, fieldValue] of Object.entries(setFields)) {
			// Must defer the set-value call because of the mp-widget-reload event that is triggered next
			window.setTimeout(() => {
				$(`#${fieldId}`).val(fieldValue).triggerNative('change');
			});
		}
	};

	// Add change handler to handle the setFields data attribute
	$elem.on('change.setFieldsChangeHandler', () => {

		// Handle selects
		if (elemType === 'SELECT') {

			// Get selected options
			const $selected = $elem.find('option').filter(':selected');

			$selected.each(function() {
				const $option = $(this);
				const setFields = $option.data('setFields');

				if (setFields) {
					doSetFields(setFields);
				}
			});
		}
		// Inputs / Textarea
		else {
			const changeSetFields = $elem.data('changeSetFields');

			if (changeSetFields) {
				const { setFields, value } = changeSetFields;

				// Change only if the input text matches the value
				if (setFields && (value === $elem.val())) {
					if (setFields) {
						doSetFields(setFields);
					}
				}
			}
		}
	});
};

/**
 * @param {HTMLSelectElement} select
 */
const handleSelectRemote = (select) => {

	const $elem = $(select);

	// Remote-action logic
	handleRemoteAction($elem);
};

/**
 * @param {HTMLInputElement} input
 */
const handleInputRemote = (input) => {

	const $elem = $(input);

	// Remote-action logic
	handleRemoteAction($elem);
};

/**
 * @param {JQuery} $elem
 * @param {{ $defaultOptions?: JQuery<HTMLOptionElement> }} opt
 */
const handleRemoteAction = ($elem, opt = {}) => {

	const data = $elem.data();
	const elemType = $elem[0].nodeName;
	const url = data.remoteUrl;
	let { $defaultOptions } = opt;

	if (!url) {
		console.warn('Missing data-remote-url value for element', this);
		return;
	}

	// Save the default options
	if ((elemType === 'SELECT') && !$defaultOptions?.length) {
		$defaultOptions = $elem.find('option').filter(function() {
			return !this.value;
		});
	}

	// Remote action handler
	const remoteAction = () => {
		const args = data.remoteArgs || {};
		const params = {};

		// Get params from form elements
		if (args) {
			for (const v of Object.keys(args)) {

				// 'fields' is a special parameter, no selector, send as is
				if (v === 'fields') {
					params[v] = args[v];
				}
				// Rest of the args have the id selector
				else {
					/** @type {string[]} */
					const arg = Array.isArray(args[v]) ? args[v] : [args[v]];
					params[v] = arg.map(v => $(`#${v}`).val()).join(',');
				}
			}
		}

		// Abort the previous request
		if (data.ref && data.ref.abort) {
			data.ref.abort();
		}

		// Assign the abort method on a ref object on the element's data
		data.ref = {};

		doFetch(url, { data: params }, { ref: data.ref, cache: true })
			.then((/** @type {{id: number|string; text: string; setFields?: any}[]} */ values) => {

				// Handle select
				if (elemType === 'SELECT') {
					const options = [];
					for (const val of values) {
						const $option = $(new Option(val.text, String(val.id), false, false));
						options.push($option);

						// Auto-set field values
						if (val.setFields) {
							$option.data('setFields', val.setFields);
						}
					}

					$elem.empty().append($defaultOptions).append(options);
				}
				// Handle input
				else if (elemType === 'INPUT') {
					for (const val of values) {

						const canSetValue = val.text.toLowerCase() === String($elem.val()).toLowerCase();

						// Auto-set field values
						if (val.setFields) {

							// First make sure the value matches the input value
							if (canSetValue) {
								// Assign the changeSetFields to element data so we can process them in the other handler
								$elem.data('changeSetFields', { value: $elem.val(), setFields: val.setFields });
								// This is not needed if proper handler order is ensured (the setFieldsChangeHandler must be assigned last)
								$elem.triggerHandler('change.setFieldsChangeHandler');
							}
						}
						// Remove the changeSetFields so there are no side-effects
						else {
							$elem.data('changeSetFields', null);
						}
					}
				}
			})
			.catch((error) => {
				console.log('err %o', error);
			})
			.finally(() => {
				// Discard the data ref object
				data.ref = null;
			});
	};

	// Create a throttle function
	const throttledRemoteAction = (e) => {

		let delay = 233;

		if (e) {
			switch (e.type) {

				case 'mp-widget-reload': {
					e.stopPropagation();
					delay = 233;
					break;
				}

				case 'change': {
					delay = 100;
					break;
				}

				case 'input': {
					delay = 633;
					break;
				}
			}
		}

		data.remoteThrottleTimer && window.clearTimeout(data.remoteThrottleTimer);
		data.remoteThrottleTimer = window.setTimeout(remoteAction, delay);
	};

	// Execute the action on init
	// Not a good idea because on post with errors the current selection will be lost
	// remoteAction();

	// Bind handler for custom event
	// @ts-ignore
	$elem.on('mp-widget-reload.action-remote', throttledRemoteAction);

	// Add the change handler for inputs only
	if (elemType === 'INPUT') {
		$elem.on('change.action-remote, input.action-remote', throttledRemoteAction);
	}
};

/**
 * @param {string} eventName
 * @param {JQuery<HTMLElement>} $elem
 * @param {any} data
 */
const handleOnEvent = (eventName, $elem, data) => {

	const actions = [];

	// Set the value of other elements
	if (data.setFields) {

		for (const [fieldId, field] of Object.entries(data.setFields)) {

			actions.push((e) => {
				const $field = $(`#${fieldId}`);
				let val;
				let triggerChange = false;

				// Set multiple options
				if (field && typeof field === 'object') {
					// Set value from other field
					if (field.element) {
						val = $(field.element).val();
					}
					// Dynamic value from other sources
					else if (field.useValue) {
						const { useValue } = field;

						// Send value of the triggering element
						if (useValue === 'self') {
							val = $elem.val();
						}
						// Send value passed through the event detail
						else if (useValue === 'eventDetail') {
							val = e.originalEvent.detail;
						}
						// Invalid
						else {
							console.warn('Incorrect `useValue` provided: %o (element: %o)', useValue, $elem[0]);
						}
					}
					// Set hardcoded value
					else if (field.value) {
						val = field.value;
					}
					// Also trigger change
					if (field.triggerChange === true) {
						triggerChange = true;
					}
				}
				// Set hardcoded value
				else {
					val = field;
				}

				if (typeof val !== 'undefined') {
					$field.val(val);
					if (triggerChange) {
						$field.triggerNative('change');
					}
				}
				else {
					console.warn('No setFields for %o', $field[0]);
				}
			});
		}
	}

	// Set html content of other elements
	if (data.setContent) {

		for (const [fieldId, field] of Object.entries(data.setContent)) {

			actions.push((e) => {
				const $field = Number.isInteger(Number(fieldId)) ? $(field.selector) : $(`#${fieldId}`);
				let content;

				if ($field.length === 0) {
					console.warn('[setContent] Element not found for: %o', data.setContent);
					return;
				}

				// Set multiple options
				if (field && typeof field === 'object') {
					// Set value from other field
					if (field.element) {
						content = $(field.element).html();
					}
					// Dynamic value from other sources
					else if (field.useValue) {
						const { useValue } = field;

						// Send value of the triggering element
						if (useValue === 'self') {
							content = $elem.html();
						}
						// Send value passed through the event detail
						else if (useValue === 'eventDetail') {
							content = e.originalEvent.detail;
						}
						// Invalid
						else {
							console.warn('Incorrect `useValue` provided: %o (element: %o)', useValue, $elem[0]);
						}
					}
					// Set hardcoded value
					else if ('value' in field) {
						content = String(field.value || '');
					}
				}
				// Set hardcoded value
				else {
					content = field;
				}

				if (typeof content !== 'undefined') {
					$field.html(content);

					// Remove tooltips
					mpro.closeSimpleOverlays();
				}
				else {
					console.warn('[setContent] No content/value for %o', $field[0]);
				}
			});
		}
	}

	// Set element data
	if (data.setData) {

		if (!Array.isArray(data.setData)) {
			console.warn('Expected data-on-change.setData to be Array');
		}
		else {
			let i = -1;
			for (const info of data.setData) {
				++i;

				if (!Array.isArray(info)) {
					console.warn(`Expected data-on-change.setData[${i}] to be Array`);
					continue;
				}

				const [element, data] = info;

				if (!element || (typeof element !== 'string')) {
					console.warn(`Expected data-on-change.setData[${i}][0] to be string`);
					continue;
				}
				if (!data || (typeof data !== 'object') || Array.isArray(data)) {
					console.warn(`Expected data-on-change.setData[${i}][1] to be hash`);
					continue;
				}
				console.log('Adding setData event on %o with data: %o', this, data);

				actions.push(() => {
					$elem.data(Object.fromEntries(Object.entries(data).map(v => [v[0], $(`#${v[1]}`).val()])));
					console.log('Set data for %o with data: %o', $elem[0], $elem.data());
				});
			}
		}
	}

	if (data.callFunction) {
		const fnName = data.callFunction;
		actions.push(() => {
			/** @type {function} */
			// @ts-ignore
			const fn = window[fnName];

			try {
				fn($elem.val(), $elem);
			}
			catch (error) {
				console.warn('Change handler[%o] error: %o', 'callFunction', error);
			}
		});
	}

	// Trigger event on other elements
	if (data.trigger) {

		const triggerOpt = data.trigger;
		const eventName = triggerOpt.name;

		if (!eventName) {
			console.warn('Change handler[%o] error: %o', 'trigger', 'No event \'name\' provided');
		}
		else {

			actions.push(() => {

				let detail = triggerOpt.detail || null;

				// Replace special keywords
				if (detail) {
					detail = replaceEventDetailKeywordsRecursive(detail, $elem);
				}

				// Prepare the custom event
				const event = new CustomEvent(eventName, { detail });
				const target = triggerOpt.target ? $(triggerOpt.target)[0] : $elem[0];

				if (target) {
					target.dispatchEvent(event);
				}
				else {
					console.warn('Change handler[%o] error: %o', 'trigger', 'Target does not exist: %o', triggerOpt.target);
				}
			});
		}
	}

	// Trigger element reload
	if (data.reloadWidgets) {

		/** @type {string[]} */
		const elements = Array.isArray(data.reloadWidgets) ? data.reloadWidgets : [data.reloadWidgets];

		for (const elem of elements) {
			const $elem = $(`#${elem}`);
			if ($elem.length === 0) {
				continue;
			}

			actions.push(() => {
				$elem.val(null)
					.triggerNative('mp-widget-reload')
					.triggerNative('change');
			});
		}
	}

	// Reload drawer
	if (data.reloadDrawer) {

		const actionData = data.reloadDrawer || {};
		const { url } = actionData;
		const route = new URL(url || document.URL, window.location.origin);
		const method = 'POST';
		const $form = $elem.closest('form');
		const $submit = $form.find('button[type="submit"]');

		if (document.querySelector('.offcanvas.show')) {
			actions.push(async () => {
				// Add loading animation
				mpro.addContentLoader($form);
				$submit.prop('disabled', true);
				try {
					await doXhr(route.toString(), { method, data: $form.serialize(), headers: { 'X-Remote-Signature': 'fragment' } });
				}
				finally {
					mpro.shop.section.reloadContainer('div.offcanvas.show div.offcanvas-content');
					// Remove the loading animation
					mpro.removeContentLoader($form);
					$submit.prop('disabled', false);
				}
			});
		}
	}

	// Reload section
	if (data.updateSections || data.reloadSections) {

		const actionData = data.updateSections || data.reloadSections || {};
		const sectionIds = actionData.sections;
		const { url } = actionData;
		const dataParents = actionData.dataParents ? [actionData.dataParents].flat() : null;

		// debugger;
		if (!sectionIds) {
			return;
		}

		/** @type {string[]} */
		const sections = Array.isArray(sectionIds) ? sectionIds : [sectionIds];

		actions.push(() => {
			// sections.forEach(sectionId => {
			// 	const $section = $(`[data-section-id="${sectionId}"]`);
			// 	console.log('section', $section);

			// 	if (!$section.length) {
			// 		return;
			// 	}

			// 	$section.trigger(new $.Event('mp-section-reload'), [url, $elem.closest('form').serialize()]);
			// });

			const $form = $elem.closest('form');
			const $submit = $form.find('button[type="submit"]');
			const $dataElements = dataParents ? dataParents.reduce((all, v) => all.add($(v)), $()).find('input,select,textarea,button').not(':disabled,[name=""]') : $form;

			// Add loading animation
			mpro.addContentLoader($form);
			$submit.prop('disabled', true);
			try {
				mpro.shop.section.reloadDelayed(sections, { url, data: $dataElements.serialize() });
			}
			finally {
				// Remove the loading animation
				mpro.removeContentLoader($form);
				$submit.prop('disabled', false);
			}
		});
	}

	// Delete row
	if (data.deleteRow) {

		for (const [fieldId, field] of Object.entries(data.deleteRow)) {

			actions.push((e) => {
				// Get the row
				// ? If data.deleteRow is array-like and the fieldId is a number, then get the row by the provided selector or default to the last form row that contains the element
				// ? If data.deleteRow is object-like, then get the row by the provided id from fieldId
				const $row = Number.isInteger(Number(fieldId)) ? (field.selector
					? $(field.selector)
					: $elem.parents(mpro.config.ui.form_row_selector).last()
				) : $(`#${fieldId}`);

				if ($row.length === 0) {
					console.warn('[deleteRow] No row found for %o', $elem[0]);
					return;
				}

				// const onContainerEmpty = field.onContainerEmpty || null;

				if (field.animated) {
					const $clone = $row.clone();
					$clone.addClass('disabled');
					$clone.find('[name]').removeAttr('name');
					$clone.find('input,select,textarea,button').prop('disabled', true);
					$clone.css({ position: 'absolute', top: $row.position().top, left: $row.position().left, width: $row.width() });
					$clone.appendTo($row.parent());
					$clone.fadeOut('normal', () => $clone.remove());
				}

				$row.remove();

				// Remove tooltips
				mpro.closeSimpleOverlays();
			});
		}
	}

	// Submit form
	if ('submit' in data) {

		const submitConf = typeof data.submit === 'object' ? data.submit : {};

		const submitForm = () => {

			/** @type {HTMLFormElement} */
			let form;

			// Get form from conf
			if (submitConf.form) {
				if (typeof submitConf.form === 'string') {
					form = $(submitConf.form).get(0);
				}
				else {
					form = document.createElement('form');
					/** @type {JQuery<HTMLFormElement>} */ // @ts-ignore
					const $form = $(form);

					// Add all attributes and hive the form
					$form.attr(submitConf.form).hide();

					// Set default action
					if (!form.action) {
						form.action = document.URL;
					}

					// Set default method
					if (!form.method) {
						form.method = 'POST';
					}

					// Put extra url params as form inputs
					if (form.method.toLowerCase() === 'get') {

						// Rebuild the form action
						const submitUrl = new URL(form.action);

						// Append element params
						for (const [name, value] of submitUrl.searchParams.entries()) {
							$('<input>').attr({ type: 'hidden', name, value }).appendTo($form);
						}

						form.action = submitUrl.href;
					}

					// Append element params
					for (const { name, value } of $elem.serializeArray()) {

						const $existingInput = $form.find(`[name="${name}"]`);

						// Remove empty params
						if (submitConf.removeEmptyParams && (value === '')) {
							$existingInput.remove();
						}
						else {
							if ($existingInput.length > 0) {
								$existingInput.val(value);
							}
							else {
								$('<input>').attr({ type: 'hidden', name, value }).appendTo($form);
							}
						}
					}

					// Delete the form on submit (it prevents navigation back issues)
					$form.on('submit', (e) => {
						setTimeout(() => $form.remove());
					});

					// Add the form to the doc
					mpro.get$B().append($form);
				}
			}
			// Use the parent form
			else {
				// @ts-ignore
				// eslint-disable-next-line prefer-destructuring
				form = $elem[0].form;
			}

			// Simulate the requestSubmit method (buggy on some older Safari versions, so we use custom implementation)
			if (form) {
				/** @type {HTMLButtonElement|HTMLInputElement} */
				// @ts-ignore
				let submitter = $(form).find('button[type="submit"],input[type="submit"]').not(':disabled').get(0);

				if (!submitter) {
					submitter = document.createElement('input');
					submitter.type = 'submit';
					submitter.hidden = true;
					form.append(submitter);
					submitter.click();
					submitter.remove();
				}
				else {
					submitter.click();
				}
			}
		};

		const throttleSubmitForm = () => {
			const delay = ('delay' in submitConf) ? Number(submitConf.delay) : 333;
			data.submitThrottleTimer && window.clearTimeout(data.submitThrottleTimer);
			data.submitThrottleTimer = window.setTimeout(submitForm, delay);
		};

		actions.push(throttleSubmitForm);
	}

	// Dismiss components (drawer/modal/tooltip/toast)
	if (data.dismiss && (typeof data.dismiss === 'string')) {

		actions.push(() => {
			switch (data.dismiss) {
				case 'drawer':
				case 'offcanvas': {
					mpro.closeDrawer();
					break;
				}

				case 'modal': {
					mpro.closeModal();
					break;
				}

				case 'toast': {
					mpro.closeToast();
					break;
				}

				default: {
					console.warn('Invalid dismiss target: %o', data.dismiss);
				}
			}
		});
	}

	// Attach the change handler
	$elem.on(`${eventName}.action-on-${eventName}`, (e) => {
		for (const action of actions) {
			action(e);
		}
	});
};

/**
 * @param {JQuery.ClickEvent} e
 */
const handleClickActivateRow = (e) => {
	e.preventDefault();

	const $trigger = $(e.target);
	const $target = $trigger.next();

	$trigger.fadeOut(0);
	$target.show('fast').find('input,select,textarea').prop('disabled', false);
};

/**
 * @param {JQuery} $widgets
 */
const processFormChangeWidgets = ($widgets) => {

	$widgets.each(function() {
		const $widget = $(this);
		const data = $widget.data('change-handler');
		const subWidgetsWithHandlers = [];

		// Auto map to 'true'
		if (data.checked) {
			const wd = Array.isArray(data.checked) ? data.checked : (data.checked ? [data.checked] : []);
			if (!data.values) {
				data.values = {};
			}
			delete data.checked;
			data.values['true'] = wd;
		}

		// Auto map to 'false'
		if (data.unchecked) {
			const wd = Array.isArray(data.unchecked) ? data.unchecked : (data.unchecked ? [data.unchecked] : []);
			if (!data.values) {
				data.values = {};
			}
			delete data.unchecked;
			data.values['false'] = wd;
		}

		if (data.values) {
			for (let [, ids] of Object.entries(data.values)) {
				if (ids) {
					if (!Array.isArray(ids)) {
						ids = [ids];
					}

					// Look for widgets that already have change-handlers inside out collection
					for (const id of ids) {
						if ($widgets.filter(`#${id}`).length > 0) {
							subWidgetsWithHandlers.push(id);
						}
					}
				}
			}
		}

		// Add sub widgets
		data.subWidgetsWithHandlers = subWidgetsWithHandlers;
	});

	return $widgets;
};

/**
 * @param {HTMLElement} element
 */
const handleFormChangeWidgets = (element) => {

	const $element = $(element);
	const data = $element.data('change-handler');
	/** @type {string[]} */
	let widgets = [];
	/** @type {string} */
	let allSelectors;
	/** @type {{ [key: string]: string; }} */
	const mapValues = {};

	// Got values map
	if (data.values) {

		for (const [value, ids] of Object.entries(data.values)) {
			let wd = Array.isArray(ids) ? ids : (ids ? [ids] : []);
			// Keep unique values
			wd = [...new Set(wd)];
			widgets = [...widgets, ...wd];
			mapValues[value] = wd.map(v => `#${v}`).join(',');
		}
	}

	// Keep unique values
	widgets = [...new Set(widgets)];
	allSelectors = widgets.map(v => `#${v}`).join(',');

	const isCompound = (data.compound === true);
	const widgetsSelector = Array.isArray(data.trigger) ? data.trigger.map(v => `#${v}`).join(',') : null;
	const subWidgetsWithHandlers = data.subWidgetsWithHandlers || [];

	// Bind the change handler
	mpro.formWidgetsHandleBindChange({
		trigger: $element,
		widgetsSelector,
		rowSelector: mpro.config.ui.form_row_selector,
		isCompound,
		allWidgetSelectors: allSelectors,
		subAllWidgetSelectors: subWidgetsWithHandlers.map(v => `#${v}`).join(','),
		mapValuesToWidgetSelectors: mapValues,
		actions: ['disable', 'hide'],
	});

	// debugger;
};

/**
 * Process special actions bound on form or form elements
 *
 * @param {JQuery<HTMLElement>|HTMLElement} container
 *
 * @returns {void}
 */
mpro.handleFormActions = (container) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);
	const $formElements = $container.find('input,textarea,select');

	// Allow de-selecting radio inputs
	for (const input of $formElements.filter('input[type="radio"][data-allow-uncheck]')) {

		/** @type {JQuery<HTMLInputElement>} */
		// @ts-ignore
		const $input = $(input);
		let data = $input.data();
		if (!data) {
			data = {};
			$input.data(data);
		}

		/** @type {JQuery<HTMLLabelElement>} */
		// @ts-ignore
		let $label = $input.closest('label');
		if (input.id) {
			$label = $label.add($input.closest('form').find(`label[for="${input.id}"]`));
		}

		// Use the mouseup event to save the 'checked' prop (the click event already has this processed)
		$input.on('mouseup.allow-uncheck', (e) => {

			// @ts-ignore
			if (input.checked) {
				// Pass uncheck instruction to the click handler (which is executed after the mouseup handler)
				data.__doUncheck = true;
			}
		});

		// Also treat label clicks
		$label.on('click.allow-uncheck', (e) => {

			// @ts-ignore
			if (input.checked) {
				// Pass uncheck instruction to the click handler (which is executed after the mouseup handler)
				data.__doUncheck = true;
			}
		});

		// Use the click handler to do the uncheck in a hacky way
		$input.on('click.allow-uncheck', (e) => {

			// Check uncheck instruction sent from the mouseup handler (this is necessary because the browser sets the "checked=true" prop natively somewhere between 'mouseup' and 'click' events)
			if (data.__doUncheck === true) {
				data.__doUncheck = false;
				// @ts-ignore
				input.checked = false;
				// Manually trigger both 'input' and 'change' events, same as when the browser does it natively
				triggerEvent(input, 'input', { bubbles: true });
				triggerEvent(input, 'change', { bubbles: true });
			}
		});
	}

	// Auto-populate select from remote
	for (const select of $formElements.filter('select[data-remote-url]')) {
		// @ts-ignore
		handleSelectRemote(select);
	}

	// Auto-populate input from remote
	for (const input of $formElements.filter('input[data-remote-url]')) {
		// @ts-ignore
		handleInputRemote(input);
	}

	// Get all widgets with change-handlers (control visibility) and process their data
	const $triggerWidgets = processFormChangeWidgets($container.find('[data-change-handler]'));

	// Bind the change events to hide/show other fields
	// Note: this must come BEFORE the widgets that have the [data-on-change]
	for (const element of $triggerWidgets) {
		handleFormChangeWidgets(element);
	}

	const $onClickTargets = $container.find('a,button,input[type="button"],div,span,li,i,em,svg');

	// Bind the click event for various predefined actions
	for (const element of $onClickTargets.filter('[data-on-click]')) {
		const $elem = $(element);
		const data = $elem.data('on-click');
		handleOnEvent('click', $elem, data || {});
	}

	const $onChangeTargets = $formElements;

	// Bind the change event for various predefined actions
	// Note: this must come AFTER the widgets that have the [data-change-handler]
	for (const element of $onChangeTargets.filter('[data-on-change]')) {
		const $elem = $(element);
		const data = $elem.data('on-change');
		handleOnEvent('change', $elem, data || {});
	}

	const $onEventTargets = $container.find('section,main').add($onClickTargets.add($onChangeTargets));

	// Event agnostic handlers
	for (const element of $onEventTargets.filter('[data-on-event]')) {
		const $elem = $(element);
		const eventsData = $elem.data('on-event');

		for (const eventType in eventsData) {
			if (Object.hasOwn(eventsData, eventType)) {
				handleOnEvent(eventType, $elem, eventsData[eventType] || {});
			}
		}
	}

	// Enable 'setFields' change action (must be the last 'change' handler in queue)
	for (const elem of $formElements) {
		handleSetFieldsChange(elem);
	}

	// Bind the click event on triggers to activate rows
	const $activateButton = $container.find('[data-activate-row]');
	// @ts-ignore
	$activateButton.on('click.activate-row', handleClickActivateRow);
	// Disable inputs to prevent autocomplete trigger
	$activateButton.siblings().find('input,select,textarea').prop('disabled', true);

	// TODO
	// $container.find('[data-replace-url]').each(function () {

	// 	const $container = $(this);
	// 	const data = $container.data();
	// 	const url = data.replaceUrl;

	// 	if (!url) {
	// 		console.warn('Missing data-replace-url value for element', this);
	// 		return;
	// 	}

	// 	// Find trigger elements
	// 	$container.find('input[type="checkbox"],input[type="radio"]').each(function () {

	// 		const $elem = $(this);

	// 		const remoteSubmit = async () => {

	// 			/** @type {JQuery<HTMLFormElement>} */
	// 			// @ts-ignore
	// 			const $form = $elem.closest('form');

	// 			await doFetch($form.attr('action'), {
	// 				method: $form.attr('method') || 'POST',
	// 				data: new FormData($form[0]),
	// 			})
	// 				.then(resp => {
	// 					const $parent = $form.parent();
	// 					$form.replaceWith(resp);
	// 					// Re-bind form actions
	// 					mpro.initStatics($parent);

	// 				})
	// 				.catch(err => {
	// 					console.warn(err);
	// 					mpro.toast('error', 'Something went wrong');
	// 				});
	// 		};

	// 		// Bind handler for custom event
	// 		// @ts-ignore
	// 		$elem.on('mp-replace.action-remote', remoteSubmit);
	// 	});
	// });

	/**
	 * Handle form ajax submission
	 */
	// @ts-ignore
	$container.find('form[data-ajax-submit]').on('submit.action-submit', /** @this {HTMLFormElement} */ async function handleFormAjaxSubmit(e) {

		e.preventDefault();

		const form = this;
		const $form = $(form);
		const data = $form.data();
		const allowRestore = ('allowRestore' in data) && (data.allowRestore === '' || data.allowRestore === true);
		let $context;

		// Select closest context
		if (data.context) {

			// One of the parents
			$context = $form.closest(data.context);

			// Somewhere else
			if ($context.length === 0) {
				$context = $(data.context);
			}

			// No context found
			if ($context.length === 0) {
				mpro.toast('error', `Invalid form submit context provided: data-context="${data.context}"`);
				return;
			}
			// Only one context is allowed
			else if ($context.length > 1) {
				$context = $context.first();
			}
		}
		// Use the form as the default context
		else {
			$context = $form;
		}

		// Save a reference to the context parent for later
		const $parent = $context.parent();

		// Load the partial content in place
		const partial = await loadPartial($context, {
			type: data.ajaxType || 'fragment',
			url: data.submitUrl || $form.attr('action') || document.URL,
			method: $form.attr('method') || 'GET',
			// @ts-ignore
			data: (form.enctype === 'multipart/form-data') ? new FormData(form) : $form.serialize(),
			loader: ('submitLoader' in data) ? Boolean(data.submitLoader) : false,
			animation: ('submitAnimation' in data) ? Boolean(data.submitAnimation) : true,
			replaceContainer: ('replaceContainer' in data) ? Boolean(data.replaceContainer) : true,
			restoreOriginal: (allowRestore === true),
		});

		// Got redirect location
		if (partial.redirect) {
			// Close everything
			mpro.closeAllOverlays();
			return void mpro.setLocation(partial.redirect/* , { replace: true } */);
		}
		// Got success/error message
		else if (partial.message) {
			// Display the message in a toast
			mpro.toast(partial.message.type || 'info', partial.message.content);

			// Get modal parent
			// TODO: replace with MpModal.SELECTOR
			const $modal = $parent.closest(`.${MpModal.NAME}`);

			if ($modal.length > 0) {
				const instance = MpModal.getInstance($modal);

				if (instance) {
					instance.hide();
				}
			}
		}
	});
};

export default mpro;
